// extracted by mini-css-extract-plugin
module.exports = {"teamcontainer":"DasTeam_teamcontainer__dmeh9"};